import React from "react";

import { components } from "../../components/select";

const OPTION_STYLES = {
    container: { display: "flex", alignItems: "center", gap: "10px" },
    image: { width: "28px", height: "42px", objectFit: "cover", borderRadius: "3px" },
    name: { margin: 0 },
};

// Module scope: declaring this inside a component would create a new
// component type every render and remount the menu mid-interaction.
const Option = React.memo((props) => {
    const { image, label } = props.data || {};
    return (
        <components.Option {...props}>
            <div style={OPTION_STYLES.container}>
                {image && <img src={image} alt={label} style={OPTION_STYLES.image} />}
                <p style={OPTION_STYLES.name}>{label}</p>
            </div>
        </components.Option>
    );
});

/** The summary picker's options, with their covers — editor and day editor. */
export const SELECT_COMPONENTS = { Option };
